/**
 * Permission links are shared rows. A sync reads them as identity plus a readable title,
 * and writes them back as identity only — sending any other column rewrites the
 * permission row itself instead of just re-linking it.
 */
/** Relation columns a sync selects for a `permissions` link. */
export const PERMISSION_SELECT_COLS = ["id", "title"];
/** Dotted form of {@link PERMISSION_SELECT_COLS}, for flat `select()` calls. */
export const PERMISSION_SELECT_PATHS = [
    "permissions.id",
    "permissions.title",
];
const readId = (entry) => {
    const id = entry?.id;
    return typeof id === "string" && id.length > 0 ? id : undefined;
};
/** Pull side: `[{ id, title }]`, or `undefined` when there is nothing linked. */
export function toPermissionRefs(value) {
    if (!Array.isArray(value))
        return undefined;
    const refs = [];
    for (const entry of value) {
        const id = readId(entry);
        if (!id)
            continue;
        const title = entry.title;
        refs.push(typeof title === "string" ? { id, title } : { id });
    }
    return refs.length > 0 ? refs : undefined;
}
/** Push side: `[{ id }]`. An empty array is kept, since it clears the links. */
export function toPermissionIds(value) {
    if (!Array.isArray(value))
        return undefined;
    return value
        .map(readId)
        .filter((id) => id !== undefined)
        .map((id) => ({ id }));
}
//# sourceMappingURL=permissions.js.map